import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../environments/environment';
import { ApiService } from 'app/api.service';
import { LoaderService } from 'app/loader.service';
import { HubService } from 'app/hub.service';
import { ChartsService } from 'app/charts.service';

@Component({
  selector: 'app-shareview',
  templateUrl: './shareview.component.html',
  styleUrls: ['./shareview.component.scss']
})
export class ShareviewComponent implements OnInit {

  // Define some public variables
  urlWorkoutId: "";
  urlWorkoutTitle: "";
  workout: object = {};
  profileChartOptions: any;
  // zoneChartOptions: any;

  constructor(
    public apiService: ApiService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private hubService: HubService,
    private chartsService: ChartsService
  ) { }

  ngOnInit() {
    this.loaderService.setLoaded();
    this.urlWorkoutId = this.route.snapshot.params.id; // get the ID
    this.urlWorkoutTitle = this.route.snapshot.params.title; // get the title

    if (this.route.snapshot.params.id) {
      // load seletced workout
      this.getWorkout(this.route.snapshot.params.id);
    }
    
  }

  // load our workout
  getWorkout(workout) {
    this.hubService.getResource('Workout', { "objectId": workout }, 1, null, null, null)
      .subscribe(
      workouts => {
        this.workout = workouts[0];
        this.buildProfile(this.workout['workoutType']);
        this.loaderService.setLoaded();
      },
      error => {
        console.log(error);
      }
      );
  }

  /**
  * Build the profile config object for highcharts including the series data arrays
  * @param {Object} workout - the workout object retuned from the API
  */
   buildProfile(workoutType) {

    var workoutProfileObject = {};
    var workoutType = workoutType;
    var zonePowerTimes = [];
    if (workoutType == 'mmp') {
      workoutProfileObject = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }; // TODO: why did I use an object?
      zonePowerTimes = [0, 0, 0, 0, 0, 0, 0, 0];
    } else {
      workoutProfileObject = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [] }; // TODO: why did I use an object?
      zonePowerTimes = [0, 0, 0, 0, 0, 0];
    }
    var runningDuration = 0;
    var plotLinesLaps = [];

    // loop the segments and create the profile array data for highcharts
    for (var i = 0; i < this.workout['segments'].length; i++) {

      // add to the laps array if needed
      if (this.workout['segments'][i].lap === true) {
        plotLinesLaps.push({
          color: "rgba(0, 0, 0, .2)",
          dashStyle: "Dash",
          value: (runningDuration),
          width: "1",
          zIndex: 22,
          label: { enabled: false }
        });
      }

      // what zone is this segment
      let segmentZone = this.getMmpPowerZone(this.workout['segments'][i].start, 'ftp');

      // loop through the zones arrays and add this segment to the correct array and NULL
      // to the others to create breaks/gaps. This is so we can use miltiple series and so multiple colours
      for (var key in workoutProfileObject) {
        if (key != segmentZone.toString()) {
          workoutProfileObject[segmentZone].push([runningDuration, null]);
        } else {
          // profile
          workoutProfileObject[segmentZone].push([runningDuration, this.workout['segments'][i].start]);
          runningDuration += this.workout['segments'][i].duration;
          workoutProfileObject[segmentZone].push([runningDuration, this.workout['segments'][i].start]);

        }
      }

    }

    // get the configs
    this.profileChartOptions = this.chartsService.workoutProfileChart(workoutProfileObject, workoutType, plotLinesLaps);

  }

  getMmpPowerZone(percentMmpPower, workoutType) {

    const mmpPowerBands = [0, 35, 45, 55, 65, 75, 85, 100, 1000];
    const ftpPowerBands = [0, 55, 75, 90, 105, 120, 150, 1000];
    // const mmpHrBands = [0, 60, 65, 75, 82, 89, 94, 100, 1000];
    // const ftpHrBands = [0, 60, 65, 75, 82, 89, 94, 100, 1000];

    if (workoutType == 'ftp') {
      if (percentMmpPower > ftpPowerBands[0] && percentMmpPower < ftpPowerBands[1]) { return 0; }
      else if (percentMmpPower >= ftpPowerBands[1] && percentMmpPower <= ftpPowerBands[2]) { return 1; }
      else if (percentMmpPower >= ftpPowerBands[2] && percentMmpPower <= ftpPowerBands[3]) { return 2; }
      else if (percentMmpPower >= ftpPowerBands[3] && percentMmpPower <= ftpPowerBands[4]) { return 3; }
      else if (percentMmpPower >= ftpPowerBands[4] && percentMmpPower <= ftpPowerBands[5]) { return 4; }
      else if (percentMmpPower >= ftpPowerBands[5] && percentMmpPower <= ftpPowerBands[6]) { return 5; }
      else { return 0; }
    } else {
      if (percentMmpPower > mmpPowerBands[0] && percentMmpPower < mmpPowerBands[1]) { return 0; }
      else if (percentMmpPower >= mmpPowerBands[1] && percentMmpPower <= mmpPowerBands[2]) { return 1; }
      else if (percentMmpPower >= mmpPowerBands[2] && percentMmpPower <= mmpPowerBands[3]) { return 2; }
      else if (percentMmpPower >= mmpPowerBands[3] && percentMmpPower <= mmpPowerBands[4]) { return 3; }
      else if (percentMmpPower >= mmpPowerBands[4] && percentMmpPower <= mmpPowerBands[5]) { return 4; }
      else if (percentMmpPower >= mmpPowerBands[5] && percentMmpPower <= mmpPowerBands[6]) { return 5; }
      else if (percentMmpPower >= mmpPowerBands[6] && percentMmpPower <= mmpPowerBands[7]) { return 6; }
      else if (percentMmpPower >= mmpPowerBands[7] && percentMmpPower <= mmpPowerBands[8]) { return 7; }
      else { return 0; }
    }

  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/shareview/shareview.component.ts